// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'selection-cursor';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M16.315 11.65c.104-.042.17-.062.232-.123a.327.327 0 0 0 0-.463c-.062-.062-.082-.098-.232-.142-.15-.044-7.42-2.502-7.42-2.502a.656.656 0 0 0-.832.832s2.516 7.321 2.547 7.42c.03.1.07.17.131.232a.328.328 0 0 0 .464 0c.061-.061.075-.096.121-.231l1.286-3.707s3.6-1.272 3.703-1.315zm-15.672.427a1.23 1.23 0 0 0 1.23 1.23M1.874 1A1.231 1.231 0 0 0 .643 2.23m12.307 0A1.23 1.23 0 0 0 11.72 1M5.566 1h2.461M5.566 13.308h.615m6.769-7.385v.615M.643 5.923v2.462'
  />
);

export const viewBox = '0 0 18 18';
